import React, { useMemo } from 'react';
import { AppData } from '../../data/appData';
import { detectPlatform, trackDownload } from '../../utils/downloads';
import './StoreBadges.scss';

interface StoreBadgesProps {
    app: AppData;
    placement: string;
    size?: 'md' | 'lg';
    align?: 'start' | 'center';
}

const StoreBadges: React.FC<StoreBadgesProps> = ({ app, placement, size = 'lg', align = 'start' }) => {
    // Put the visitor's own store first.
    const platform = useMemo(detectPlatform, []);

    const badges = [
        app.appStoreLink && {
            store: 'appstore' as const,
            href: app.appStoreLink,
            img: '/images/download_app_store.png',
            alt: `Download ${app.name} on the App Store`,
        },
        app.googlePlayLink && {
            store: 'googleplay' as const,
            href: app.googlePlayLink,
            img: '/images/download_google_play.png',
            alt: `Get ${app.name} on Google Play`,
        },
    ].filter(Boolean) as { store: 'appstore' | 'googleplay'; href: string; img: string; alt: string }[];

    if (platform === 'android') badges.reverse();

    return (
        <div className={`store-badges store-badges--${size} store-badges--${align}`}>
            {badges.map((b) => (
                <a
                    key={b.store}
                    href={b.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-badge"
                    onClick={() => trackDownload(app.id, b.store, placement)}
                >
                    <img src={b.img} alt={b.alt} />
                </a>
            ))}
        </div>
    );
};

export default StoreBadges;
